export default "__VITE_ASSET__CQ5ys2tF__"